import { useHook, useMutationHook } from '../utils/use-hook'
import { mutationFetcher } from '../utils/default-fetcher'
import type { MutationHook, HookFetcherFn } from '../utils/types'
import type { SetNewPasswordHook } from '../types/setNewPassword'
import type { Provider } from '..'

export type UseSetNewPassword<
  H extends MutationHook<SetNewPasswordHook<any>> = MutationHook<SetNewPasswordHook>
> = ReturnType<H['useHook']>

export const fetcher: HookFetcherFn<SetNewPasswordHook> = mutationFetcher

const fn = (provider: Provider) => provider.auth?.useSetNewPassword!

const useSetNewPassword: UseSetNewPassword = (...args) => {
  const hook = useHook(fn)
  return useMutationHook({ fetcher, ...hook })(...args)
}

export default useSetNewPassword
